export const permissionsAccessAdminConsole = ["acessar-admin-console"];

export const permissionsConfigPlatform = [
  "visualizar-configuracoes-da-plataforma",
  "editar-configuraçoes-da-plataforma",
];

export const permissionsConfigDesign = [
  "visualizar-configuracoes-de-design",
  "editar-configuracoes-de-design",
];

export const permissionsConfigSales = [
  "visualizar-configuracoes-de-vendas",
  "editar-configuracoes-de-vendas",
];
export const permissionsConfigDomain = [
  "visualizar-configuracoes-de-dominios",
  "gerenciar-configuracoes-de-dominios",
];
export const permissionsConfigBillboard = [
  "visualizar-configuracoes-da-billboard",
  "gerenciar-configuracoes-da-billboard",
];

export const permissionsItemsMenu = [
  "visualizar-itens-do-menu",
  "gerenciar-itens-do-menu",
];

export const permissionsAccessPermissionPage = [
  "visualizar-funcoes-de-permissoes",
  "criar-funcoes-de-permissoes",
  "associar-eou-remover-funcoes-de-usuario",
];

export const permissionsConfigPermissions = [
  "visualizar-funcoes-de-permissoes",
  "criar-funcoes-de-permissoes",
  "editar-funcoes-de-permissoes",
  "excluir-funcoes-de-permissoes",
  "associar-eou-remover-funcoes-de-usuario",
];

export const permissionsAuth = [
  "visualizar-configuracoes-de-autenticacao",
  "gerenciar-configuracoes-de-autenticacao",
];

export const permissionsTransactions = [
  "visualizar-metricas",
  "visualizar-transacoes",
  "realizar-acao-do-reembolso",
  "reenviar-cobranca-aguardando-pagamento",
  "enviar-uma-nova-cobranca",
];

export const permissionsAccessPageTransactions = [
  "visualizar-metricas",
  "visualizar-transacoes",
];

export const permissionsUser = [
  "criar-usuario-manualmente",
  "visualizar-lista-de-usuarios-excluidos",
  "visualizar-lista-de-usuarios-ativos",
  "editar-informacoes-de-usuarios",
  "Visualizar detalhes de usuários específicos",
  "realizar-impersonacao-de-contas",
  "restaurar-usuarios-excluidos",
  "excluir-contas-de-usuarios",
];
export const permissionsAccess = ["visualizar-acessos-vendidos"];

export const permissionsPromoter = [
  "visualizar-configuracoes-do-programa",
  "editar-configuracoes-do-programa",
  "gerenciar-solicitacoes-do-programa",
  "remover-afiliado-do-programa",
];

export const permissionsAppStore = [
  "visualizar-webhook",
  "visualizar-historico-de-envios",
  "visualizar-pixel-de-rastreamento",
  "visualizar-configuracoes-de-emissao",
  "visualizar-configuracoes-de-integracao",
];

export const permissionsExport = [
  "emitir-e-baixar-relatorio-de-usuarios-cadastrados",
  "emitir-e-baixar-relatorio-de-inscricoes-em-grupos",
  "emitir-e-baixar-relatorio-de-situacoes-individuais",
];

export const permissionsImport = [
  "importar-usuarios",
  "importar-inscricoes-em-grupos",
];
